/**
 * Email-verification state helpers.
 *
 * Sharetribe's `emailVerified` is no longer the whole story: at checkout the
 * server may verify a buyer's email programmatically (Integration API) so
 * Sharetribe delivers the order receipt — and stamps
 * privateData.emailAutoVerified when it does. Such users still need to be
 * prompted to REALLY verify (click the link) until the actual verification
 * click stamps privateData.emailVerifiedByUser. Every UI that decides
 * "should we nag about verification?" reads through here.
 */

const privateDataOf = user => user?.attributes?.profile?.privateData || {};

/** True when the "verified" status came from the checkout auto-verify, not a click. */
export const isEmailAutoVerifiedOnly = user => {
  const pd = privateDataOf(user);
  return !!pd.emailAutoVerified && !pd.emailVerifiedByUser;
};

/** Should the app prompt this user to verify their email? */
export const needsEmailVerificationPrompt = user => {
  if (!user?.id) return false;
  const emailVerified = user.attributes?.emailVerified === true;
  return !emailVerified || isEmailAutoVerifiedOnly(user);
};
